export enum QuotationStatusEnum {
  NONE = 'NONE',
  NEW = 'NEW', // nouvelle demande de devis

  // Transporter
  TRANSPORTER_ACCEPTED = 'TRANSPORTER_ACCEPTED', // le transporteur à accepter
  TRANSPORTER_REJECTED = 'TRANSPORTER_REJECTED', // le transporteur à rejeter
  TRANSPORTER_EXPIRED_PICKUP_DATE = 'TRANSPORTER_EXPIRED_PICKUP_DATE', // new : la demande est expiré, car le transporteur n'a pas répondu avant la pickupDate

  // Customer
  CUSTOMER_ACCEPTED = 'CUSTOMER_ACCEPTED', // le chargeur accepte la proposition du transporteur
  CUSTOMER_REJECTED = 'CUSTOMER_REJECTED', // le chargeur refuse la proposition du transporteur
  CUSTOMER_EXPIRED_VALIDITY_DATE = 'CUSTOMER_EXPIRED_VALIDITY_DATE', // new : la demande est expiré car le chargeur n'a pas répondu avant la date de validité du devis
  CUSTOMER_EXPIRED_PICKUP_DATE = 'CUSTOMER_EXPIRED_PICKUP_DATE', // new : la demande est expiré car le chargeur n'a pas répondu avant la pickupDate du devis
  CUSTOMER_ACCEPTED_BUT_EXPIRED_VALIDITY_DATE = 'CUSTOMER_ACCEPTED_BUT_EXPIRED_VALIDITY_DATE', // le chargeur à accepter la proposition du transporteur mais n'a pas finaliser le paiement avant la date de validité du devis (blocage panier)
  CUSTOMER_ACCEPTED_BUT_EXPIRED_PICKUP_DATE = 'CUSTOMER_ACCEPTED_BUT_EXPIRED_PICKUP_DATE', // le chargeur à accepter la proposition du transporteur mais n'a pas finaliser le paiement avant la date de pickup du devis (blocage panier)
  FINALIZED = 'FINALIZED',
}
export interface QuotationStats {
  quotationStatus: string;
  quotationCount: number;
}
export interface NewQuotationsStats {
  responseRate: number;
  timingRate: number;
}
